import api from './api';

export const homeService = {
  async getAvailableMinutes() {
    return api.get('/calls/available-minutes');
  },
  
  async initiateCall() {
    return api.post('/calls/initiate');
  },

  async getCallHistory(page = 0, limit = page === 0 ? 3 : 50) {
    const skip = page === 0 ? 0 : 3 + ((page - 1) * 50);
    return api.get(`/calls/history?skip=${skip}&limit=${limit}`);
  },

  async getReadingHistory(page = 0, limit = page === 0 ? 3 : 50) {
    const skip = page === 0 ? 0 : 3 + ((page - 1) * 50);
    return api.get(`/reading/history?skip=${skip}&limit=${limit}`);
  },

  async clearReadingHistory() {
    return api.delete('/reading/history');
  },

  async getPublicReviews() {
    const response = await fetch('/api/v1/reviews/public');
    if (!response.ok) return [];
    return response.json();
  }
}; 